import React from 'react';
import { t } from '../../utils/i18n';
import { BAN_ACTION, getBanAction, getUserId } from '../../utils/userBanActions';

/**
 * Ban or Unban button for a single user row / modal header.
 */
export default function UserBanActionButton({
  user,
  runBanAction,
  isPending,
  pendingUserId,
  className = '',
  stopPropagation = false,
}) {
  const action = getBanAction(user);
  if (!action) {
    return <span className="text-dark-text-muted text-xs">—</span>;
  }

  const userId = getUserId(user);
  const isRowPending = isPending && pendingUserId === userId;
  const isBan = action === BAN_ACTION;

  const handleClick = (e) => {
    if (stopPropagation) e.stopPropagation();
    runBanAction(user);
  };

  const baseClass =
    'px-2.5 py-1 rounded text-xs font-medium border transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
  const variantClass = isBan
    ? 'border-red-500/50 text-red-400 hover:bg-red-500/10'
    : 'border-green-500/50 text-green-400 hover:bg-green-500/10';

  return (
    <button
      type="button"
      disabled={isRowPending}
      onClick={handleClick}
      className={`${baseClass} ${variantClass} ${className}`.trim()}
    >
      {isRowPending
        ? t('user.ban.processing')
        : isBan
          ? t('user.ban.button')
          : t('user.ban.unban.button')}
    </button>
  );
}
